module.exports = __webpack_public_path__ + "static/media/informaticaelettronicaImg.62c2d0d9.png";